// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  firebase: {
    projectId: 'baby-tracker-app-d48b3',
    appId: '1:504371268080:web:ac04a59d1912e39a9e3535',
    storageBucket: 'baby-tracker-app-d48b3.appspot.com',
    apiKey: 'AIzaSyAagx0axqNEUuojS9uE3TAN4Qtglh2rrYQ',
    authDomain: 'baby-tracker-app-d48b3.firebaseapp.com',
    messagingSenderId: '504371268080',
    measurementId: 'G-JPRYDJX0D7',
  },
  production: false
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
